import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

const findOnePaymentNotice = createAsyncThunk(
  "paymentNoticeDetail/findone",
  async (id: number, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(`${api.baseURL}paymentNotice/${id}`, {
        method: "GET",
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default findOnePaymentNotice;
